import axios from 'axios';

const { VUE_APP_BASE_URL } = process.env;

export const fetchMap = (projectId, params) => axios({
  url: `/projects/${projectId}/map`,
  baseURL: `${VUE_APP_BASE_URL}/api/ocean/v2/`,
  params
});

export default {
  fetchMap
};
